import { Box, Typography } from '@mui/material';
import { AvailableGiftDTO, CouponsV2AvailableGiftDTO } from 'probonio-shared-ui/api';
import { useTranslation } from 'react-i18next';
import { resolveGiftOccasionKey } from './giftOccasionKey';

interface Props {
  gift: AvailableGiftDTO | CouponsV2AvailableGiftDTO;
}

export const GiftMetaLines: React.FC<Props> = ({ gift }) => {
  const { t, i18n } = useTranslation('benefitModule');
  const occasionKey = resolveGiftOccasionKey(gift);
  const occasion = occasionKey
    ? t(`giftsStack.occasionReason.${occasionKey}`, { defaultValue: occasionKey })
    : t('giftsStack.occasionReason.OTHER');
  const payoutDate = gift.payoutDate ? i18n.format(new Date(gift.payoutDate), 'monthAndYear') : null;
  const amount = i18n.format(gift.amount, 'euro');

  return (
    <>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          display: 'block',
        }}
      >
        {t('giftsStack.occasion', { occasion })}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 0.5,
          alignItems: 'baseline',
        }}
      >
        <Typography
          variant="body2"
          component="span"
          sx={{
            color: 'text.secondary',
          }}
        >
          {payoutDate}
        </Typography>
        <Typography
          variant="body2"
          component="span"
          sx={{
            color: 'text.secondary',
          }}
        >
          |
        </Typography>
        <Typography
          variant="body2"
          component="span"
          sx={{
            fontWeight: 'bold',
            color: 'text.primary',
          }}
        >
          {amount}
        </Typography>
      </Box>
    </>
  );
};
